export default __webpack_public_path__ + "static/media/speaker-active-grey.9fa13976.svg";